enum UtilityDataFeatureType {
  FAQ = "FAQ",
  DISPLAY_NOTE = "DISPLAY_NOTE",
  EVENT_TRIGGER = "EVENT_TRIGGER"
}

export default UtilityDataFeatureType;
